<template>
<div>
    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>
        Partners
        <a href="/clinics/new" class="btn btn-default btn-sm">
          Lägg till
        </a>
    </h1>

    <div class="searchbar">
        <div>

            <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right" style="margin-bottom:18px;">
                <i class="fa fa-file" aria-hidden="true"></i> Spara excel</i>
            </a>

            <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök namn, adress, mail etc" />
            </div>

            <div class="block" v-bind:class="{ active: search.is_public == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.is_public" /> Publicerad i klippkort
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contract_internal == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.contract_internal" /> Mottagningsmassage
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contract_external == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.contract_external" /> Företagsmassage
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contract_pt == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.contract_pt" /> Personlig träning
                </label>
            </div>

 <br style="clear: left;">
            <div class="block" v-bind:class="{ active: search.status != null }">
                <label>
                    <select v-model="search.status" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Status</option>
                        <option v-bind:value="1">Prospect</option>
                        <option v-bind:value="3">Inaktiv</option>
                        <option v-bind:value="2">Aktiv</option>
                        <option v-bind:value="5">Pausad</option>
                        <option v-bind:value="4">Avslutad</option>
                        <option v-bind:value="6">Avslutat prospekt</option>
                        <option v-bind:value="7">Inaktivt prospekt</option>
                    </select>
                </label>
            </div>

          <div class="block" v-bind:class="{ active: search.prospect_product_area != null }">
            <label>
              <select v-model="search.prospect_product_area" v-on:change="updateQuery()">
                <option v-bind:value="undefined">Prospect tjänsteområde</option>
                <option v-bind:value="area.id" v-for="area in product_areas">{{ area.name }}</option>
              </select>
            </label>
          </div>

            <div class="block" v-bind:class="{ active: search.next_contact != null }">
                <label>
                    Visa nästa kontaktdatum:
                    <select v-model="search.next_contact" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Alla användare</option>
                        <option v-bind:value="user.id" v-for="user in users">{{ user.name }}</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.seen_prices == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.seen_prices" /> Ej sett nya priser
                </label>
            </div>

            <br clear="all">
        </div>
    </div>
</div>
</template>

<script>

export default {
    props: {
        query: {
            required: true
        },
        loading: {},
        searchbarData: {}
    },
    data: function () {
        return {
            search: {},
            users: this.searchbarData.users,
            product_areas: this.searchbarData.product_areas
        }
    },
    methods: {

        updateQuery: function () {
            this.$emit('search', this.search)
        }

    },
    watch: {
        query: function () {
            this.search = this.query
        }
    }
}

</script>
